import { Boundary, ScreenBox2D } from './types';
import { Box2, Vector2 } from 'three';

export const isBoxIntersectsBoundary = (boundary: Boundary) => (box: ScreenBox2D) => {
  const boundaryBox = new Box2(new Vector2(boundary.minX, boundary.minY), new Vector2(boundary.maxX, boundary.maxY));
  const screenBox = new Box2(new Vector2(box.x, box.y), new Vector2(box.x + box.width, box.y + box.height));
  return boundaryBox.intersectsBox(screenBox);
};
